import { PREMIUM } from '../constants'

const premiumActions = {
    updatePremiumAndTrial(premiumSettings) {
        return {
            type: PREMIUM.UPDATE_WIDGET_PREMIUM_AND_TRIAL,
            payload: premiumSettings,
        }
    },
    updateSomePremiumParams(someParams) {
        return {
            type: PREMIUM.UPDATE_WIDGET_SOME_PREMIUM_PARAMS,
            payload: someParams,
        }
    },

}

export { premiumActions }